import React, { Component } from 'react';
import { DateTimeHelper } from '../Helpers/DateTimeHelper';

import { t } from '../locales/i18n';
export class OrderDetails extends Component {
    static displayName = OrderDetails.name;

    constructor(props) {
        super(props);
        this.state = props.data;

        // Check all parts to ensure we have something to display.
        this.hasAddress = this.state.shippingStreet ||
            this.state.shippingCity ||
            this.state.shippingState ||
            this.state.shippingZip ||
            this.state.shippingCountry;

        this.hasDestinationCityStateZip = this.state.destinationCity || this.state.destinationState || this.state.destinationZip;

        this.hasShippingCityStateZip = this.state.shippingCity || this.state.shippingState || this.state.shippingZip;

        this.destCityStateDelim = this.state.destinationCity && (this.state.destinationState || this.state.destinationZip) ? ',' : '';
    }

    render() {
        return (
            <div>
                {t('orderDetails.orderNumber')} <br />
                <div className='order-details bottom-20'>{this.state.orderNumber}</div>
                <div className={this.state.poNumber ? '' : 'hide'}>
                    {t('orderDetails.customerPoNumber')} <br />
                    <div className='order-details bottom-20'>{this.state.poNumber}</div>
                </div>
                <div className={this.state.loadId ? '' : 'hide'}>
                    {t('orderDetails.loadId')} <br />
                    <div className='order-details bottom-20'>{this.state.loadId}</div>
                </div>
                {t('orderDetails.orderCreationDate')} <br />
                <div className='order-details bottom-20'>{DateTimeHelper.formatDateTime(this.state.orderCreateDate, 'll')}</div>
                <div className={this.state.shipmentType === 'SmallCarrier' ? 'bottom-20' : 'hide'}>
                    <div className={this.state.carrierTrackingNumber ? '' : 'hide'}>
                        {t('orderDetails.proTrackingNumber')} <br />
                        <div className='order-details bottom-20'>{this.state.carrierTrackingNumber}</div>
                    </div>
                    Carrier Name: <br />
                    <div className='order-details bottom-20'>{this.state.carrierName ? this.state.carrierName : '--'}</div>
                    <div className={this.state.originWarehouse ? '' : 'hide'}>
                        {t('orderDetails.shippingPointOrigin')} <br />
                        <div className='order-details bottom-20'>{`${this.state.shippingCity}, ${this.state.shippingState}`}</div>
                    </div>
                    {t('orderDetails.deliveryLocation')} <br />
                    <div className={this.state.destinationStreet ? 'order-details' : 'hide'}>{this.state.destinationStreet}</div>
                    <div className={this.hasDestinationCityStateZip ? 'order-details' : 'hide'}>{this.state.destinationCity}{this.destCityStateDelim} {this.state.destinationState} {this.state.destinationZip}</div>
                    <div className={this.state.destinationCountry ? 'order-details' : 'hide'}>{this.state.destinationCountry}</div>
                    {!this.hasAddress &&
                        <div className='order-details'>--</div>
                    }
                </div>
                <div className={this.state.shipmentType === 'WillCall' ? '' : 'hide'}>
                    <div className={this.state.requestedDate ? '' : 'hide'}>
                        {t('orderDetails.requestedPickupDate')} <br />
                        <div className='order-details bottom-20'>{DateTimeHelper.formatDateTime(this.state.requestedDate, 'lll')}</div>
                    </div>
                    <div className={this.hasAddress ? '' : 'hide'}>
                        {t('orderDetails.pickupLocation')} <br />
                        <div className={this.state.shippingStreet ? 'order-details' : 'hide'}>{this.state.shippingStreet}</div>
                        <div className={this.hasShippingCityStateZip ? 'order-details' : 'hide'}>{this.state.shippingCity} {this.state.shippingState} {this.state.shippingZip}</div>
                        <div className={this.state.shippingCountry ? 'order-details' : 'hide'}>{this.state.shippingCountry}</div>
                    </div>
                </div>
            </div>
        );
    }
}
